import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { userActions } from '../../redux/actions'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import Loader from '../../components/Loader/Loader'

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      emailVerified: false,
      error: '',
    }
  }

  componentDidMount() {
    const { history, verifyEmail } = this.props

    const code = this.getCodeFromParams()
    if (code) {
      verifyEmail(code)
        .then(() => setTimeout(() => this.setState({ emailVerified: true }), 3000))
        .catch(error => {
          this.setState({ error: error && error.message ? error.message : String(error) })
        })
        .finally(() => this.setState({ loading: false }))
    } else {
      history.push('/')
    }
  }

  getCodeFromParams() {
    const { location } = this.props
    if (!location.search) {
      return null
    }

    const params = location.search.split('?')[1].split('&')
    const code = params
      .map(param => ({
        key: param.split('=')[0],
        value: param.split('=')[1],
      }))
      .find(param => param.key === 'code')
    return code && code.value
  }

  renderBody() {
    const { loading, error } = this.state

    if (loading) {
      return (
        <div aria-live="polite" aria-busy="true">
          <span>Verifying your email...</span>
          <Loader noBorder />
        </div>
      )
    }

    if (error) {
      return (
        <div role="alert" aria-live="assertive">
          <FormattedMessage
            id="error.email.verifyFailed"
            values={{ error: error ? `: ${error}` : '' }}
          />
        </div>
      )
    }

    const link = `http://${process.env.RAZZLE_HOSTNAME}`

    return (
      <div>
        <FormattedMessage id="success.email.verified" />
        <br />
        <Link to="/" aria-label="Return to home page">
          {link}
        </Link>
      </div>
    )
  }

  render() {
    const { emailVerified } = this.state
    const { intl } = this.props

    if (emailVerified) {
      return <Redirect to="/claim-reward" />
    }
    const label = intl.formatMessage({ id: 'global.label.verifyEmail' })

    return (
      <div className="reset-password-page" role="main" aria-label="Verify Email Main">
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1 className="page-title">
            <FormattedMessage id="global.label.verifyEmail" />
          </h1>
          {this.renderBody()}
        </div>
      </div>
    )
  }
}

const { verifyEmail } = userActions
const ConnectedComponent = connect(null, { verifyEmail })(VerifyEmail)
ConnectedComponent.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
}

export default injectIntl(withRouter(ConnectedComponent))
